module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('div', {
    staticClass: "vip-page"
  }, [(!_vm.pageData.id) ? _c('div', {
    staticClass: "nologin"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'login',
        'query': {}
      }),
      expression: "{name:'login','query':{ }}"
    }],
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "danger",
      "plain": "",
      "round": "",
      "size": "large"
    }
  }, [_vm._v("登录/注册")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      mohu: !(_vm.pageData.id > 0)
    }
  }, [_c('div', {
    staticClass: "vip-header"
  }, [_c('div', {
    staticClass: "vip-header-top"
  }, [(_vm.pageData.face) ? _c('img', {
    staticClass: "face",
    attrs: {
      "src": _vm.pageData.face
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.pageData.name))]), _vm._v(" "), _c('van-rate', {
    staticStyle: {
      "padding": "3px 0 0 6px",
      "float": "left"
    },
    attrs: {
      "value": _vm.pageData.group_star,
      "size": 12,
      "count": _vm.pageData.group_star,
      "color": "#FAAD14",
      "disabled-color": "#FD2840"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cf"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cf"
  }), _vm._v(" "), _c('div', {
    staticClass: "vip-card"
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'cmsDetail',
        'query': {
          id: 5
        }
      }),
      expression: "{name:'cmsDetail','query':{id :5 }}"
    }],
    staticClass: "icon-question"
  }), _vm._v(" "), _c('p', {
    staticClass: "title1"
  }, [_vm._v("可用积分")]), _vm._v(" "), _c('p', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.pageData.score1))]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("可直接使用积分抵现")]), _vm._v(" "), _c('div', {
    staticClass: "vip-progress"
  }, [_c('div', {
    staticClass: "done",
    style: ({
      width: _vm.pageData.up_percent
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v(_vm._s(_vm.pageData.current_group.name) + "(" + _vm._s(_vm.pageData.current_group.score) + ")")]), _vm._v(" "), _c('span', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm.pageData.next_group.name) + "(" + _vm._s(_vm.pageData.next_group.score) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "cf"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "vip-rights"
  }, [_c('div', {
    staticClass: "vip-rights-header"
  }, [_vm._v("尊享特权")]), _vm._v(" "), _c('div', {
    staticClass: "flex-wrap"
  }, [_c('div', {
    staticClass: "item flex-item-1"
  }, [_vm._v(_vm._s(_vm.pageData.rights[0]))]), _vm._v(" "), _c('div', {
    staticClass: "item flex-item-1"
  }, [_vm._v(_vm._s(_vm.pageData.rights[1]))]), _vm._v(" "), _c('div', {
    staticClass: "item flex-item-1"
  }, [_vm._v(_vm._s(_vm.pageData.rights[2]))]), _vm._v(" "), _c('div', {
    staticClass: "item flex-item-1"
  }, [_vm._v(_vm._s(_vm.pageData.rights[3]))])])]), _vm._v(" "), _c('div', {
    staticClass: "score-btn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "danger",
      "plain": "",
      "round": "",
      "size": "large"
    },
    on: {
      "click": _vm.updateScore
    }
  }, [_vm._v("同步积分")])], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-601c1586","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/vip.vue
// module id = 2422
// module chunks = 0